import * as React from 'react';
import NextPreviousButtons from '../NextPreviousButtons';
import AlchoholConsumptionQuestion from './AlchoholConsumptionQuestion';

import {
	CheckboxGroup,
	ToggleSwitch,
	FormCheckConditional,
	TextInput,
	Label,
	DropdownInput
} from '../../../../components/forms';

interface Props {
	questions: any;
	questionnaire: any;
	onQuestionnaireBlur: (e: any) => Promise<any>;
	onQuestionnaireChange: (value?: {}) => void;
	nextStep: (e: any) => void;
	prevStep: (e: any) => void;
}
const OtherQuestion: React.StatelessComponent<Props> = props => {
	const isNextDisabled = function () {
		var valid =
			!(props.questionnaire.abroad == null
				|| props.questionnaire.consumedAlcohol == null
				|| props.questionnaire.usedTobacco == null
				|| props.questionnaire.cannabis == null
				|| props.questionnaire.controlledSubstances == null
				|| props.questionnaire.substanceCounseling == null
			);
		if (props.questionnaire.usedTobacco === true) {
			if (props.questionnaire.usedTobaccoLastUsed === undefined) {
				valid = false;
			}
			else if (!props.questionnaire.cigarettes
					&& !props.questionnaire.cigarillos
					&& !props.questionnaire.cigars
					&& !props.questionnaire.chewingTobacco
					&& !props.questionnaire.electronicCigarettes
					&& !props.questionnaire.nicotineSubstitutes
					&& !props.questionnaire.shisha
					&& !props.questionnaire.pipes
					&& !props.questionnaire.otherTobacco
				) {
				valid = false;
			}
			if (props.questionnaire.cigars === true) {
				if (!props.questionnaire.cigarCount) {
					valid = false;
				}
			}
		}
		if (props.questionnaire.cannabis === true) {
			if (!props.questionnaire.cannabisCount) {
				valid = false;
			}
		}
		if (props.questionnaire.abroad === true) {
			if (props.questionnaire.foreignTravelList === undefined || props.questionnaire.foreignTravelList.length === 0) {
				valid = false;
			}
		}
		if (props.questionnaire.consumedAlcohol === true) {
			if (props.questionnaire.drinksPerWeekday === undefined
				|| props.questionnaire.drinksPerWeekend === undefined
				|| props.questionnaire.drinksPerSitting === undefined) {
				valid = false;
			}
		}
		if (props.questionnaire.otherViolations === true) {
			if (props.questionnaire.otherViolationsCount === undefined) {
				valid = false;
			}
		}
		return !valid;
	};

	return (
		<div>
			<AlchoholConsumptionQuestion {...props} />
			<ToggleSwitch
				labelText={props.questions.usedTobacco}
				name="usedTobacco"
				onChildren="Yes"
				offChildren="No"
				onBlur={props.onQuestionnaireBlur}
				onChange={props.onQuestionnaireChange}
				checked={props.questionnaire.usedTobacco}
				className="toggle-yes-no"
				conditionalChildren={
					<FormCheckConditional isOpen={props.questionnaire.usedTobacco} className="ml-0">
						<DropdownInput
							labelText={props.questions.usedTobaccoLastUsed}
							name="usedTobaccoLastUsed"
							value={props.questionnaire.usedTobaccoLastUsed}
							onBlur={props.onQuestionnaireBlur}
							onChange={props.onQuestionnaireChange}
							defaultOption="Select ..."
							options={[
								{ value: 'withinThePastMonth', text: 'Within the past month' },
								{ value: 'withinThePast6Months', text: '1-6 months ago' },
								{ value: 'withinThePast12Months', text: '6-12 months ago' },
								{ value: 'withinThePast24Months', text: '12-24 months ago' }
							]}
						/>
						<CheckboxGroup
							className="mb-2"
							title={props.questions.usedTobaccoWhich}
							checkOptions={[
								{
									name: 'cigarettes',
									label: props.questions.cigarettes,
									checked: props.questionnaire.cigarettes,
									onBlur: props.onQuestionnaireBlur,
									onChange: props.onQuestionnaireChange
								},
								{
									name: 'cigarillos',
									label: props.questions.cigarillos,
									checked: props.questionnaire.cigarillos,
									onBlur: props.onQuestionnaireBlur,
									onChange: props.onQuestionnaireChange
								},
								{
									name: 'cigars',
									label: props.questions.cigars,
									checked: props.questionnaire.cigars,
									onChange: props.onQuestionnaireChange,
									conditionalChildren: (
										<FormCheckConditional isOpen={props.questionnaire.cigars}>
											<TextInput
												labelText={props.questions.cigarCount}
												name="cigarCount"
												pattern="[0-9]*"
												value={props.questionnaire.cigarCount}
												onBlur={props.onQuestionnaireBlur}
												onChange={props.onQuestionnaireChange}
											/>
										</FormCheckConditional>
									)
								},
								{
									name: 'chewingTobacco',
									label: props.questions.chewingTobacco,
									checked: props.questionnaire.chewingTobacco,
									onBlur: props.onQuestionnaireBlur,
									onChange: props.onQuestionnaireChange
								},
								{
									name: 'electronicCigarettes',
									label: props.questions.electronicCigarettes,
									checked: props.questionnaire.electronicCigarettes,
									onChange: props.onQuestionnaireChange
								},
								{
									name: 'nicotineSubstitutes',
									label: props.questions.nicotineSubstitutes,
									checked: props.questionnaire.nicotineSubstitutes,
									onChange: props.onQuestionnaireChange
								},
								{
									name: 'shisha',
									label: props.questions.shisha,
									checked: props.questionnaire.shisha,
									onChange: props.onQuestionnaireChange
								},
								{
									name: 'pipes',
									label: props.questions.pipes,
									checked: props.questionnaire.pipes,
									onChange: props.onQuestionnaireChange
								},
								{
									name: 'otherTobacco',
									label: props.questions.otherTobacco,
									checked: props.questionnaire.otherTobacco,
									onChange: props.onQuestionnaireChange
								}
							]}
						/>
					</FormCheckConditional>}
			/>
			<ToggleSwitch
				labelText={props.questions.cannabis}
				name="cannabis"
				onChildren="Yes"
				offChildren="No"
				onBlur={props.onQuestionnaireBlur}
				onChange={props.onQuestionnaireChange}
				checked={props.questionnaire.cannabis}
				className="toggle-yes-no"
				conditionalChildren={
					<FormCheckConditional isOpen={props.questionnaire.cannabis} className="ml-0">
						<div className="form-group mb-2">
							<Label>{props.questions.cannabisCount}</Label>
							<div className="form-inline">
								<TextInput
									name="cannabisCount"
									className="form-group-number"
									pattern="[0-9]*"
									value={props.questionnaire.cannabisCount}
									onBlur={props.onQuestionnaireBlur}
									onChange={props.onQuestionnaireChange}
								/>
								<div
									className="form-group form-inline-text"
									dangerouslySetInnerHTML={{ __html: props.questions.cannabisCountSpan as any }}
								/>
								<DropdownInput
									name="cannabisCountSpan"
									options={[
										{ value: 'day', text: 'Day' },
										{ value: 'week', text: 'Week' },
										{ value: 'month', text: 'Month' },
										{ value: 'year', text: 'Year' }
									]}
									value={props.questionnaire.cannabisCountSpan}
									onBlur={props.onQuestionnaireBlur}
									onChange={props.onQuestionnaireChange}
								/>
							</div>
						</div>
					</FormCheckConditional>}
			/>
			<ToggleSwitch
				labelText={props.questions.controlledSubstances}
				name="controlledSubstances"
				onChildren="Yes"
				offChildren="No"
				onBlur={props.onQuestionnaireBlur}
				onChange={props.onQuestionnaireChange}
				checked={props.questionnaire.controlledSubstances}
				className="toggle-yes-no"
			/>
			<ToggleSwitch
				labelText={props.questions.substanceCounseling}
				name="substanceCounseling"
				onChildren="Yes"
				offChildren="No"
				onBlur={props.onQuestionnaireBlur}
				onChange={props.onQuestionnaireChange}
				checked={props.questionnaire.substanceCounseling}
				className="toggle-yes-no"
			/>
			<NextPreviousButtons nextStep={props.nextStep} prevStep={props.prevStep} isNextDisabled={isNextDisabled} />
		</div>
	);
};

export default OtherQuestion;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/quoting/enrollment/create-your-account/activitiesQuestions/OtherQuestions.tsx